import React from 'react';

import Backdrop from '../Backdrop/Backdrop';

import style from './SideNav.scss';

import cn from 'classnames';

export interface ISideNavProps {
  onClose: () => void;
  className?: string;
  children: React.ReactNode;
  isOpen: boolean;
}

export default React.memo(function StyledSideNav(props: ISideNavProps) {
  const { children, isOpen = false, onClose } = props;

  return (
    <Backdrop className={style.backdrop} onOutsideClick={onClose} isOpen={isOpen}>
      <div className={cn(style.sideNav, { [style.isOpen]: isOpen })}>{children}</div>
    </Backdrop>
  );
});
